// bound-checker.js

// If needed, import any constants or dependencies.
// For example, if MarkerTypes or MapLayouts are defined elsewhere:
// import { MarkerTypes, MapLayouts } from './constants';

// Note: If some functions rely on external variables (like syncBody, layout, selectedFaction, etc.),
// you can either import them or pass them as parameters.

import {MapLayouts} from "../../shared/data/map-layout.enum";
import {MarkerFaction, MarkerTypes} from "../../shared/data/marker-type.enum";
import {markerProperties} from "../../shared/data/MarkerProperties";

export const isTooClose = (x, y, selectedMarker, markers) => {
    return markers.some((marker) => {
        const dx = marker.position.lat - x;
        const dy = marker.position.lng - y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        const isSameTeam =
            ((selectedMarker.type === MarkerTypes.GARRISON && selectedMarker.faction === MarkerFaction.FRIENDLY) && (marker.type === MarkerTypes.GARRISON && marker.faction === MarkerFaction.FRIENDLY)) ||
            ((selectedMarker.type === MarkerTypes.GARRISON && selectedMarker.faction === MarkerFaction.ENEMY) && (marker.type === MarkerTypes.GARRISON && marker.faction === MarkerFaction.ENEMY));

        return isSameTeam && distance < markerProperties[selectedMarker.type]?.[selectedMarker.faction].radius;
    });
};

export const isInsideBounds = (x, y, layout) => {
    if (layout === MapLayouts.HORIZONTAL) {
        return x >= 400 && x <= 1600 && y >= 0 && y <= 2000;
    } else {
        return x >= 0 && x <= 2000 && y >= 400 && y <= 1600;
    }
};

export const isEnemyTerritory = (x, y, layout, selectedFaction, factions, controlledTerritoryDistance, SECTOR_SIZE, extraSector) => {
    console.log(`isEnemyTerritory \n selectedFaction=${selectedFaction} \n factions=${JSON.stringify(factions)} \n controlledDistance=${controlledTerritoryDistance}`)
    if (layout === MapLayouts.HORIZONTAL) {
        if (selectedFaction === factions.left) {
            return y >= (extraSector ? controlledTerritoryDistance + SECTOR_SIZE : controlledTerritoryDistance);
        } else {
            return y <= (extraSector ? 2000 - controlledTerritoryDistance - SECTOR_SIZE : 2000 - controlledTerritoryDistance);
        }
    } else {
        if (selectedFaction === factions.left) {
            return x <= (extraSector ? 2000 - controlledTerritoryDistance - SECTOR_SIZE : 2000 - controlledTerritoryDistance);
        } else {
            return x >= (extraSector ? controlledTerritoryDistance + SECTOR_SIZE : controlledTerritoryDistance);
        }
    }
};

export const isNeutralTerritory = (x, y, layout, alliesScore, axisScore) => {
    if (alliesScore === 2 && axisScore === 2) {
        if (layout === MapLayouts.HORIZONTAL) {
            return x >= 400 && x <= 1600 && y >= 800 && y <= 1200;
        } else {
            return x >= 800 && x <= 1200 && y >= 400 && y <= 1600;
        }
    }
    return false;
};

// If you're using React, you might have wrapped isFriendlyTerritory in useCallback
// within a component. If you want it here, you can export a normal function:
export const isFriendlyTerritory = (x, y, layout, selectedFaction, factions, controlledTerritoryDistance, SECTOR_SIZE, extraSector) => {
    console.log(`isFriendlyTerritory \n selectedFaction=${selectedFaction} \n factions=${JSON.stringify(factions)} \n controlledDistance=${controlledTerritoryDistance}`)
    if (layout === MapLayouts.HORIZONTAL) {
        if (selectedFaction === factions.left) {
            return y <= (extraSector ? controlledTerritoryDistance - SECTOR_SIZE : controlledTerritoryDistance);
        } else {
            return y >= (extraSector ? 2000 - controlledTerritoryDistance + SECTOR_SIZE : 2000 - controlledTerritoryDistance);
        }
    } else {
        if (selectedFaction === factions.left) {
            return x >= (extraSector ? 2000 - controlledTerritoryDistance + SECTOR_SIZE : 2000 - controlledTerritoryDistance);
        } else {
            return x <= (extraSector ? controlledTerritoryDistance - SECTOR_SIZE : controlledTerritoryDistance);
        }
    }
};

// Exporting everything as default in one object (optional)
export default {
    isTooClose,
    isInsideBounds,
    isEnemyTerritory,
    isNeutralTerritory,
    isFriendlyTerritory
};
